import type { CityConfig } from "@/pages/city-template/types";

export const madisonWiConfig: CityConfig = {
  city: "Madison",
  state: "Wisconsin",
  stateAbbr: "WI",
  slug: "madison-wi",
  route: "/cities/madison-wi",
  title: "Emergency Passport Madison, WI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Madison, WI — as fast as 24 hours. No Wisconsin passport agency — Fast Passport Center couriers to Chicago. A+ BBB rated. Serving Dane County and central Wisconsin.",
  h1: "Emergency & Expedited Passport Services in Madison, WI",
  heroSubtitle: "Madison and Dane County have no local passport agency — the nearest is Chicago, about 150 miles south. Fast Passport Center's registered couriers deliver your documents to the Chicago Passport Agency, getting you a new or renewed passport as fast as 24–48 hours.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Madison%20Wisconsin%20State%20Capitol%20building%20dome%20at%20sunset%20reflecting%20on%20Lake%20Monona%2C%20isthmus%20between%20two%20lakes%2C%20warm%20golden%20hour%20light%20with%20vibrant%20amber%20and%20teal%20tones%2C%20professional%20architectural%20photography%2C%20wide%20angle%20view%20of%20city%20skyline%20with%20waterfront%2C%20clean%20composition%20with%20no%20text%20or%20people%20visible&width=1800&height=700&seq=madison-wi-hero-001&orientation=landscape",
  heroImageAlt: "Madison Wisconsin State Capitol dome and Lake Monona waterfront at sunset",
  geoPosition: "43.0731;-89.4012",
  geoPlacename: "Madison, Wisconsin",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 150 miles from Madison — about 2.5 hours via I-90/I-94",
  },
  nearbyCitiesZips: [
    { name: "Downtown Madison", zips: "53703, 53704" },
    { name: "University District", zips: "53706, 53711" },
    { name: "Fitchburg", zips: "53711, 53719" },
    { name: "Middleton", zips: "53562" },
    { name: "Sun Prairie", zips: "53590" },
    { name: "Verona", zips: "53593" },
    { name: "Waunakee", zips: "53597" },
    { name: "Stoughton", zips: "53589" },
    { name: "Oregon", zips: "53575" },
    { name: "Monona", zips: "53716" },
    { name: "McFarland", zips: "53558" },
    { name: "Cottage Grove", zips: "53527" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission to Chicago Passport Agency" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-graduation-cap-line", title: "UW Study Abroad", desc: "Rush passports for UW-Madison students with upcoming programs" },
    { icon: "ri-government-line", title: "State Gov Travel", desc: "Serving Wisconsin state employees and Capitol Hill staff" },
  ],
  internalLinks: [
    { name: "Emergency passport in Milwaukee WI", route: "/cities/milwaukee" },
    { name: "Expedited passport in Green Bay WI", route: "/cities/green-bay" },
    { name: "Urgent passport in Racine WI", route: "/cities/racine" },
    { name: "Wisconsin passport hub", route: "/states/wisconsin" },
    { name: "Chicago passport services", route: "/states/illinois" },
    { name: "Same-day passport in Minneapolis MN", route: "/cities/minneapolis" },
    { name: "Emergency passport in Indianapolis IN", route: "/cities/indianapolis" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Madison remotely via secure courier. Our registered couriers hand-deliver your documents directly to the Chicago Passport Agency — 150 miles south. This means Madison travelers get 24–48 hour turnaround without a 5-hour roundtrip drive to Chicago.",
  fpcOfficeDistance: "Serving all of Dane County and central Wisconsin",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Madison and all of Dane County. From the UW campus and State Capitol area to Fitchburg, Middleton, Sun Prairie, and Verona — we help central Wisconsin travelers get their passports fast.",
  nearbyCitiesIntro: "We serve Madison and surrounding Dane County communities including Middleton, Fitchburg, Sun Prairie, Verona, Waunakee, Stoughton, Monona, and McFarland.",
  howItWorksIntro: "Most Madison travelers complete everything online and ship documents overnight. No need to drive 150 miles to Chicago or wait for a passport agency appointment. Our process is designed for Wisconsin residents who need fast, reliable results.",
  mistakesIntro: "Madison travelers — especially UW students and state government employees — have unique passport needs. Here are the most common mistakes we see.",
  testimonialsIntro: "Madison travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Madison? Here are the most common ones we hear from Dane County travelers.",
  statePageRoute: "/states/wisconsin",
  statePageName: "Wisconsin",
  dmvWebsite: "https://www.dot.wisconsin.gov/drivers",
  dmvLabel: "Wisconsin DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Chicago Agency courier — no drive for you",
        "Predictable turnaround for Madison travelers",
        "Ideal for UW study abroad and government travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service USPS",
        "Good for planned travel from MSN or ORD",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "No document review — errors cause rejection",
        "In-person clerk appointment required",
        "Workload shifts with government shutdowns",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "2.5-hour drive each way to Chicago",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Madison travelers with flights within 72 hours — our couriers hand-deliver to Chicago Passport Agency, as fast as 24 hours.",
      bullets: ["24–48 hour turnaround available", "Chicago Agency courier delivery", "Perfect for UW study abroad emergencies"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Madison adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No acceptance clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-graduation-cap-line",
      title: "Study Abroad Passport",
      description: "UW-Madison students heading abroad often need passports on short notice. We specialize in fast academic passport processing.",
      bullets: ["Rush processing for enrollment deadlines", "Program acceptance letter support", "Acceptance facility scheduling near campus"],
      badge: "UW Students",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Fast replacement with DS-64 form guidance for Madison and Dane County residents.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support across Dane County.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport name change service after marriage, divorce, or legal changes for Madison residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Madison WI", description: "Urgent passport processing for Madison, WI travelers via Chicago Passport Agency courier — as fast as 24 hours." },
    { name: "Passport Renewal Madison WI", description: "Fast passport renewal for Madison and Dane County, Wisconsin residents." },
    { name: "UW Study Abroad Passport Madison", description: "Rush passport processing for University of Wisconsin-Madison students with upcoming study abroad programs." },
    { name: "Lost or Stolen Passport Madison WI", description: "Passport replacement service for Madison residents, including DS-64 form guidance." },
    { name: "Child Passport Madison WI", description: "Passport services for minors under 16 in Madison, WI with parental consent guidance." },
    { name: "Name Change Passport Madison WI", description: "Passport name change service for Madison, WI residents after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Olivia M.",
      location: "UW-Madison",
      rating: 5,
      text: "I got accepted to a study abroad program in Spain with only 3 weeks notice. My passport was expired. Fast Passport Center had a new one in my hands in 5 days. Absolutely saved my semester abroad.",
      service: "Emergency Passport",
    },
    {
      name: "David K.",
      location: "Middleton, WI",
      rating: 5,
      text: "State government job, international conference in 8 days, passport expired. Fast Passport Center handled the Chicago courier and I had my renewal in 3 business days. No 150-mile drive required.",
      service: "Expedited Renewal",
    },
    {
      name: "Lisa B.",
      location: "Fitchburg, WI",
      rating: 5,
      text: "Getting passports for our family of four before a Europe trip. Fast Passport Center walked us through everything and all four were processed within a week. Worth every penny.",
      service: "Family Passport Processing",
    },
    {
      name: "James R.",
      location: "Sun Prairie, WI",
      rating: 5,
      text: "Lost my passport a week before our anniversary trip to Mexico. Fast Passport Center guided me through the DS-64 and got me a replacement passport in just 2 days. Incredible service.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "msn-1",
      name: "Madison Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3902 Milwaukee St",
      city: "Madison",
      state: "WI",
      zip: "53714",
      phone: "(608) 246-1230",
      hours: "Mon–Fri: 8:30 AM – 5:30 PM",
      distance: "East Madison, near Milwaukee Street",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary passport acceptance facility for Madison. Appointment required. Call ahead to confirm passport service hours.",
      icon: "ri-mail-line",
    },
    {
      id: "msn-2",
      name: "Middleton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6501 University Ave",
      city: "Middleton",
      state: "WI",
      zip: "53562",
      phone: "(608) 831-3360",
      hours: "Mon–Fri: 8:30 AM – 5:00 PM",
      distance: "8 miles west of downtown Madison",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Middleton, Waunakee, and west Madison residents. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "msn-3",
      name: "Dane County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "210 Martin Luther King Jr Blvd, Room 110",
      city: "Madison",
      state: "WI",
      zip: "53703",
      phone: "(608) 266-4121",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Madison, near State Capitol",
      website: "https://dcclerk.countyofdane.com/",
      websiteLabel: "Dane County Clerk",
      notes: "Convenient for downtown Madison and State Capitol area residents. Photo services not on-site.",
      icon: "ri-government-line",
    },
    {
      id: "msn-4",
      name: "Sun Prairie Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1607 McCoy Rd",
      city: "Sun Prairie",
      state: "WI",
      zip: "53590",
      phone: "(608) 837-4180",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "12 miles northeast of downtown Madison",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Sun Prairie and eastern Dane County residents. Appointment required.",
      icon: "ri-mail-line",
    },
    {
      id: "msn-5",
      name: "Verona Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "416 N Main St",
      city: "Verona",
      state: "WI",
      zip: "53593",
      phone: "(608) 845-9680",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "12 miles southwest of downtown Madison",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Verona, Fitchburg, and Oregon residents. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "msn-6",
      name: "Stoughton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "130 S Division St",
      city: "Stoughton",
      state: "WI",
      zip: "53589",
      phone: "(608) 873-4210",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "19 miles southeast of downtown Madison",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Stoughton, McFarland, and south Dane County residents. Appointment required.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — call NPIC, limited slots in Chicago", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — 150 mile drive to Chicago via I-90", fpc: "Most Madison travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Madison-Specific Guidance", agency: "Generic — no UW, state government, or biotech expertise", fpc: "Full Madison/Chicago courier/UW study abroad knowledge built in" },
  ],
  mistakes: [
    {
      icon: "ri-graduation-cap-line",
      title: "UW Students Waiting Until Last Minute",
      description: "Many UW-Madison students realize they need a passport only after receiving program acceptance. Start your passport process the moment you apply to any study abroad or internship program.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Photo Background",
      description: "Passport photos must have a white or off-white background. Always verify before submission — a rejected photo adds weeks to your application.",
    },
    {
      icon: "ri-car-line",
      title: "Planning to Drive to Chicago Without an Appointment",
      description: "The Chicago Passport Agency requires appointments and turns away walk-ins. The 5-hour roundtrip is wasted without a pre-secured slot. We handle this for you.",
    },
    {
      icon: "ri-file-list-line",
      title: "Wrong Form Type",
      description: "Renewals use DS-82, first-time applications use DS-11. Using the wrong form is a common Dane County mistake that delays your application by weeks.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Child Consent Documents",
      description: "Both parents must appear for minor passports. One absent parent needs notarized consent on Form DS-3053. Madison families often miss this.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming MSN Has Direct International Flights",
      description: "The Dane County Regional Airport (MSN) has limited flights — most international travelers connect through Chicago or Milwaukee. Budget extra travel time and ensure your passport is ready.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes from anywhere in Madison." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send a prepaid overnight label. Drop your documents at any UPS location in Madison or Dane County." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the Chicago Passport Agency." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at the Chicago Passport Agency using our registered courier submission slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Madison address — trackable every step of the way." },
  ],
  faqs: [
    {
      q: "Does Madison or Wisconsin have its own passport agency?",
      a: "No. Wisconsin does not have a regional passport agency. The nearest option is the Chicago Passport Agency at 230 S Dearborn St, Suite 380, Chicago, IL 60604 — approximately 150 miles from Madison (2.5 hours by car). Fast Passport Center's couriers deliver directly to Chicago so Madison residents don't need to make the roundtrip drive.",
    },
    {
      q: "How fast can UW-Madison students get a passport?",
      a: "UW-Madison students with urgent study abroad or research program departures can receive a passport in as little as 24–48 hours through Fast Passport Center's emergency courier service. For planned programs, our 2–9 business day expedited service is ideal. We recommend starting the process the moment you receive your program acceptance, not when it's too late.",
    },
    {
      q: "What is the closest passport office to Madison, Wisconsin?",
      a: "The closest regional passport agency is the Chicago Passport Agency in downtown Chicago. For acceptance facilities (where first-time applicants must go), the Dane County Clerk, Madison Main Post Office, and Middleton Post Office are popular options.",
    },
    {
      q: "Can I fly internationally from Dane County Regional Airport (MSN)?",
      a: "MSN has limited direct flights. Most international travel from Madison connects through Chicago O'Hare (ORD), Midway (MDW), or Milwaukee (MKE). A valid U.S. passport is required for all international flights. Verify your passport expiration before booking any international itinerary.",
    },
    {
      q: "How fast can I renew my passport in Madison?",
      a: "With Fast Passport Center, Madison residents can renew their passport in 24–48 hours (emergency) or 2–9 business days (expedited). Standard government mail processing takes 8–11 weeks. USPS expedited mail takes 3–5 weeks. Our courier to the Chicago Passport Agency is the fastest available option for Wisconsin residents.",
    },
    {
      q: "Can I get a passport for my child in Madison?",
      a: "Yes. For minors under 16, both parents must be present at an acceptance facility (or one parent with notarized consent on Form DS-3053). Dane County Clerk and several Madison post offices accept minor passport applications. We guide Madison families through the entire process.",
    },
    {
      q: "What documents do I need for a first-time passport in Madison?",
      a: "You'll need Form DS-11, a certified Wisconsin birth certificate, a valid Wisconsin driver's license or ID, two identical passport photos, and fee payment. First-time applicants must appear in person. We provide a complete checklist and can help schedule your Dane County acceptance facility appointment.",
    },
    {
      q: "How do I get a Wisconsin birth certificate for my passport?",
      a: "Wisconsin birth certificates can be ordered through the Wisconsin Vital Records Office at the Department of Health Services. You can order online, by mail, or in person in Madison. Processing typically takes 2–4 weeks. For faster service, request a certified copy by expedited mail.",
    },
    {
      q: "Is it worth driving to Chicago for my passport from Madison?",
      a: "For most Madison travelers, driving 150 miles to Chicago is not worth it. The Chicago Passport Agency requires a pre-scheduled appointment, and if your paperwork has any issues, you may be turned away. Fast Passport Center's courier service costs less than a roundtrip drive when you factor in fuel, tolls, parking, and time — and we guarantee our turnaround.",
    },
    {
      q: "Do I need a passport for a trip to Canada from Madison?",
      a: "Yes. All travel between the U.S. and Canada by air requires a valid U.S. passport. By land or sea, you may use a REAL ID-compliant driver's license, passport card, or Enhanced Driver's License, but a passport book is strongly recommended for hassle-free crossing.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — State Street", address: "302 State St, Madison, WI 53703", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — University Ave", address: "310 University Ave, Madison, WI 53703", hours: "Mon–Sun: 7AM–10PM" },
    { name: "FedEx Office — E Washington Ave", address: "1350 E Washington Ave, Madison, WI 53703", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "UPS Store — Middleton", address: "7475 University Ave, Middleton, WI 53562", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walmart — E Towne Mall Area", address: "4502 E Washington Ave, Madison, WI 53704", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Fitchburg", address: "2700 Fish Hatchery Rd, Fitchburg, WI 53713", hours: "Mon–Sun: 7AM–10PM" },
  ],
  dmvLocations: [
    { name: "WI DMV — Madison East", address: "4802 Sheboygan Ave, Madison, WI 53705", hours: "Mon–Fri: 8:30AM–4:30PM", note: "REAL ID and driver's license renewals. Appointment recommended.", featured: true },
    { name: "WI DMV — Sun Prairie", address: "2750 Hoepker Rd, Sun Prairie, WI 53590", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Convenient for east Dane County residents.", featured: false },
    { name: "WI DMV — Middleton", address: "8417 Excelsior Dr, Middleton, WI 53562", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Full-service DMV for west Madison and Waunakee residents.", featured: false },
  ],
  airports: [
    {
      code: "MSN",
      name: "Dane County Regional Airport",
      distance: "7 miles from downtown Madison",
      address: "4000 International Ln, Madison, WI 53704",
      note: "Madison's local airport with domestic flights. International travelers typically connect through Chicago or Milwaukee.",
      flightUrl: "https://www.msnairport.com/",
      flightLabel: "MSN Airport",
      featured: true,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "150 miles south of Madison",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international hub used by most Madison travelers for overseas flights. 2.5-hour drive from Madison.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "O'Hare Airport",
      featured: false,
    },
    {
      code: "MKE",
      name: "Milwaukee Mitchell International Airport",
      distance: "80 miles east of Madison",
      address: "5300 S Howell Ave, Milwaukee, WI 53207",
      note: "Alternative airport for Madison travelers with more international connections than MSN. About 1.5-hour drive.",
      flightUrl: "https://www.mitchellairport.com/",
      flightLabel: "MKE Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from the Wisconsin Department of Health Services Vital Records. Online, mail, or in-person options available for Dane County residents.", url: "https://www.dhs.wisconsin.gov/vitalrecords/" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through Wisconsin DHS Vital Records. Required for estate, insurance, and legal matters.", url: "https://www.dhs.wisconsin.gov/vitalrecords/" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Dane County Register of Deeds. Certified copies available for name changes and legal purposes.", url: "https://www.countyofdane.com/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Dane County Clerk of Courts. Required for name change passport corrections.", url: "https://www.wicourts.gov/" },
  ],
};